import { captureException } from '@/utils/sentry';
import { formatPriceForSave } from '@/utils/price-editing';
import { PricingEdit } from '@sales-portal/domain/pricing/blocs/stores/pricing-edits-store-types';
import { UpsertPriceDraftForBusinessOrganizationInput } from '@/types';
import { useCallback } from 'react';

export const usePriceEditsTransformer = () => {
  return useCallback((pricingEdits: PricingEdit[]) => {
    return pricingEdits.reduce<UpsertPriceDraftForBusinessOrganizationInput[]>(
      (acc, edit) => {
        // Guard against missing identifiers reaching the upsert mutation.
        if (
          !edit.supplierUUID ||
          !edit.restaurantUUID ||
          !edit.variantPackUUID
        ) {
          captureException(
            new Error('Dropped price edit with missing identifiers'),
            {
              extra: {
                restaurantUUID: edit.restaurantUUID,
                supplierUUID: edit.supplierUUID,
                variantPackUUID: edit.variantPackUUID,
              },
            },
          );

          return acc;
        }

        acc.push({
          gross_profit_in_percentage: edit.grossMarginPercentage.toFixed(2),
          new_sales_rep_price_in_micros: formatPriceForSave(
            edit.priceInMicros,
          )!, // because edit.priceInMicros is always there
          restaurant_id: edit.restaurantUUID,
          supplier_id: edit.supplierUUID,
          variant_pack_id: edit.variantPackUUID,
        });

        return acc;
      },
      [],
    );
  }, []);
};
